import React from "react";
import BaseForm from "../base/BaseForm";
import ProyectoAPI from "../../api/proyectos-api";
import PlanoList from "./PlanoList";

import {
  Panel,
  Description,
  Content,
  FieldItem,
  Wizard,
  Breadcrumb
} from "../layout/Panel";
import Fa from "../common/Fa";

import Alert from "../common/Alert";
import Mapa from "../Mapa";
import geoHelper from "../../helpers/geo-helper";
import EventoList from "./EventoList";
import { Tabs, TabItem, TabContent } from "../common/Tabs";
import Table from "../common/Table";
import { FormattedNumber } from "react-intl";
import PropietarioList from "./PropietarioList";

/**
 * Componente que representa el formulario de alta y modificación
 * de un proyecto.
 */
export default class ProyectoView extends BaseForm {
  state = {};
  map = React.createRef();
  propList = React.createRef();
  id = null;
  /**
   * @constructor
   */
  constructor(props) {
    super(props);
    this.api = ProyectoAPI;
    this.message["obtener.error"] = "Proyecto.obtener.error";
    this.id = parseInt(this.props.match.params.id);
  }
  /**
   * Sobrescribe el obtener del padre para actulizar la lista de propietarios.
   */
  obtener() {
    super
      .obtener()
      .then(response => {
        let d = response.data;
        d.loading = false;
        this.propList.setData(d);
      })
      .catch(error => {
        this.propList.setData({
          loading: false
        });
      });
  }

  /**
   * Se encarga de añadir la capa de integración con el parcelario.
   */
  addPlano() {
    this.visor.addWFSLayer({
      layer: "plano",
      title: "Plano de integración",
      workspace: "snc",
      visible: true,
      filter: `id_proyecto=${this.id}`
    });
  }

  /**
   * Se encarga de setear el layer de plano para previsualizar
   * la integración con el parcelario
   */
  componentDidMount() {
    super.componentDidMount();
    this.addPlano();
  }

  /**
   * Se encarga de cosntruir el bloque del estado con iformación correspondiente
   * del estado del proyecto
   */
  estado() {
    const { estado } = this.state;
    var map = {
      REVISION: "is-danger",
      CREADO: "is-success"
    };

    return (
      <div className="control estado">
        <div className="columns">
          <div className="column">
            <div className="tags has-addons">
              <span className="tag is-dark">Estado</span>
              <span className={`tag ${map[estado]}`}>{estado}</span>
            </div>
          </div>
          <div className="column is-10">
            {estado == "CREADO" && (
              <p className="help">
                <Fa icon="info-circle" /> Para que tu proyecto sea procesado por
                el equipo del SNC, deberás <code>Remitir</code> tu proyecto. Una
                vez remitido no podrá modificar el proyecto.
              </p>
            )}
            {estado == "REVISION" && (
              <p className="help">
                <Fa icon="exclamation-circle" />
                Se econtraron algunos problemas durante la validación del
                proyecto, estos problemas se encuentra detallados en la sección
                de <code>Eventos</code>. Para poder remitir el proyecto y
                finalizar el proceso deberá subsanar los problemas detectados
                durante la validación.
              </p>
            )}
          </div>
        </div>
        <hr />
      </div>
    );
  }

  /**
   * Se encarga de construir los datos del Proyecto
   */
  renderInfo() {
    return (
      <React.Fragment>
        <h3>Datos del Proyecto</h3>
        <hr />
        <FieldItem label="Nro">{this.state.id}</FieldItem>
        <FieldItem label="Nombre">{this.state.nombre}</FieldItem>
        <FieldItem label="Departamento">{this.state.departamento}</FieldItem>
        <FieldItem label="Distrito">{this.state.distrito}</FieldItem>
        <FieldItem label="Matricula">{this.state.matricula}</FieldItem>
        <FieldItem label="Superficie">
          <FormattedNumber value={this.state.superficie} /> m<sup>2</sup>
        </FieldItem>
        {this.state.padron && (
          <FieldItem label="Padrón">{this.state.padron}</FieldItem>
        )}

        {!this.state.padron && (
          <FieldItem label="Cuenta corriente">
            {this.state.zona}-{this.state.manzana}-{this.state.lote}
          </FieldItem>
        )}
        {this.informePericial()}
      </React.Fragment>
    );
  }

  /**
   * Se encarga de consturir el tab del proyecto.
   */
  proyecto() {
    return (
      <Content>
        {this.estado()}
        <div className="columns">
          <div className="column is-4">{this.renderInfo()}</div>
          <div className="column is-1" />

          <div className="column ">
            <Mapa
              onRef={ref => (this.visor = ref)}
              onSearch={d => this.onSearch(d)}
            />
          </div>
          <hr />
        </div>
      </Content>
    );
  }

  /**
   * Se encarga de renderizar el tab que lista los eventos del proyecto.
   */
  eventos() {
    return (
      <React.Fragment>
        <h3>Eventos </h3>
        <EventoList proyecto={this.props.match.params.id} />
      </React.Fragment>
    );
  }

  /**
   * Construye la lista de parcelas correspondientes al proyecto.
   */
  parcelas() {
    let filters = {
      id_proyecto: this.id
    };
    return <PlanoList filters={filters} />;
  }

  /**
   * Se encarga de construir el tab de propietarios.
   */
  propietarios() {
    return (
      <PropietarioList onRef={ref => (this.propList = ref)} data={this.state} />
    );
  }

  remitir() {
    this.api
      .remitir()
      .then(response => {})
      .catch(error => {
        console.error(error);
      });
  }
  /**
   * Se encarga de construir el footer del proyecto.
   */
  footer() {
    const { estado } = this.state;
    if (estado == "REMITIDO" || estado == "APROBADO") {
      return "";
    } else if (estado == "REVISION") {
      return "";
    }

    return (
      <React.Fragment>
        <p className="help">
          <Fa icon="info-circle" />
          Al crear un proyecto, podrás previsualizar la integración con el
          parcelario, el proyecto quedará en un estado inicial{" "}
          <code>Creada</code>, solo tu la podrás ver. Para que tu proyecto sea
          procesado por el equipo del SNC, deberás <code>Remitir</code> tu
          proyecto.
        </p>
        <hr />
        <div className="control">
          <a className="button is-primary is-outlined">
            <Fa icon="envelope" />
            &nbsp; Remitir Proyecto
          </a>
        </div>
        <hr />
      </React.Fragment>
    );
  }

  /**
   * construye el boton de informe pericial
   */
  informePericial() {
    const { estado } = this.state;

    return (
      <React.Fragment>
        <hr />
        <div className="control">
          <a
            className="button is-primary is-outlined"
            target="_blank"
            href={`/api/v1/proyectos/${this.state.id}/informe`}
          >
            <Fa icon="file-download" />
            &nbsp; Informe Pericial
          </a>
        </div>
      </React.Fragment>
    );
  }

  /**
   * Se encarga de renderizar el componente
   */
  render() {
    return (
      <React.Fragment>
        <Wizard>
          <Breadcrumb badge="1">Proyectos</Breadcrumb>
          <Breadcrumb badge="2">Gestionar Proyectos</Breadcrumb>
          <Breadcrumb active badge="3">
            Consultar Proyecto
          </Breadcrumb>
        </Wizard>
        <Panel title="Consultar Proyectos">
          <Description>
            A travéz de esta pantalla podrás visualizar los datos del proyecto,
            previsualizar su integración con el parcelario pais y gestionar su
            presentación.
          </Description>
          <Alert onRef={ref => (this.alert = ref)} />
          <Tabs>
            <TabItem name="proyecto">Proyecto</TabItem>
            <TabItem name="propietarios">Propietarios</TabItem>
            <TabItem name="eventos">Eventos</TabItem>
            <TabItem name="parcelas">Parcelas</TabItem>
          </Tabs>

          <TabContent name="proyecto">{this.proyecto()}</TabContent>
          <TabContent name="propietarios">{this.propietarios()}</TabContent>
          <TabContent name="eventos">{this.eventos()}</TabContent>
          <TabContent name="parcelas">{this.parcelas()}</TabContent>
          <hr />
          {this.footer()}

          <a className="button">
            <Fa icon="arrow-left" />
            Atras
          </a>
        </Panel>
      </React.Fragment>
    );
  }
}
